<template>
  <div class="comments">
    <template v-if="Array.isArray(comments) && comments.length">
      <template v-for="(item, key) in comments">
        <comment-item
          :key="key"
          :item="item"
          action
        />
      </template>
    </template>
    <div
      v-else
      class="empty-comments"
    >
      <p class="text-center text-muted">
        {{ $t('string.emptyComments') }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CommentItem from '@/views/comments/components/CommentItem'

export default {
  name: 'CommentList',
  components: { CommentItem },
  props: {
    borrowId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      comments: []
    }
  },
  computed: {
    ...mapState({
      refreshCommentList: state => state.comment.refreshCommentList
    })
  },
  watch: {
    refreshCommentList () {
      this.getCommentList()
    }
  },
  methods: {
    getCommentList () {
      this.isLoading = true
      this.$axios.post(process.env.VUE_APP_API + '/api/v4/backend/comment/list', {
        borrow_id: this.borrowId
      }).then(({ data }) => {
        if (data.data) {
          this.comments = data.data
        } else {
          this.comments = []
        }
      }).catch((error) => {
        this.onResponseError(error)
      }).finally(() => {
        this.isLoading = false
      })
    }
  },
  mounted () {
    this.getCommentList()
  }
}
</script>

<style scoped>

</style>
